<template>
  <Read
    :id="+$route.params.id"
    :back-link="$currentModule.getRoute('all-articles')"
  />
</template>

<script>
import Read from '@modules/knowledge/views/read'
export default {
  name: 'ReadArticle',
  components: { Read },
}
</script>
